export default __webpack_public_path__ + "static/step1-d01c9c6a1df947d64f09daf0aeb98b8c.svg";